export default __webpack_public_path__ + "img/69454a1acc7d9593471ce75ebd61c202.svg";